import Vue from 'vue';
import ParameterConfigurationMes from '@shopworx/parameter-configuration-mes';
import MaterialManagement from '@shopworx/material-management';
import Admin from '@shopworx/admin';
import Cron from '@shopworx/cron';
import calibrationApp from '@shopworx/calibration-app';
import Masters from '@shopworx/masters';
import ProductionPlanning from '@shopworx/production-planning';
import ProductionLog from '@shopworx/production-log';
import DowntimeLog from '@shopworx/downtime-log';
import RecipeManagement from '@shopworx/recipe-management';
import RoadmapManagement from '@shopworx/roadmap-management';
import PackagingManagement from '@shopworx/packaging-management';
import ProductionProcess from '@shopworx/production-process';
import ProductionLayoutMes from '@shopworx/production-layout-mes';
import ProductManagement from '@shopworx/product-management';
import ReworkOperation from '@shopworx/rework-operation';
import DataVisualizer from '@shopworx/data-visualizer';
import DataAnalyzer from '@shopworx/data-analyzer';
import TraceabilityApp from '@shopworx/traceability-app';
import NgCodeConfiguration from '@shopworx/ng-code-configuration';
import ProductionImage from '@shopworx/production-image';
import ReportViewer from '@shopworx/report-viewer';
import Setup from '@shopworx/setup';
import Spc from '@shopworx/spc';
import UserDashboard from '@shopworx/user-dashboard';
import BillingApp from '@shopworx/billing-app';
import KpiDashboard from '@shopworx/kpi-dashboard';
import BottleneckMachineDashboard from '@shopworx/bottleneck-machine-dashboard';
import CellwiseDowntimeDashboard from '@shopworx/cellwise-downtime-dashboard';
import CellwiseQualityDashboard from '@shopworx/cellwise-quality-dashboard';
import CellwiseProductionDashboard from '@shopworx/cellwise-production-dashboard';
import emsDashboard from '@shopworx/ems-dashboard';
import OrderManagement from '@shopworx/order-management';
import ModelManagement from '@shopworx/model-management';
import ManualInbound from '@shopworx/manual-inbound';
import ManualOutbound from '@shopworx/manual-outbound';
import StockTaking from '@shopworx/stock-taking';
import Solution from '@shopworx/solution';
import Operator from '@shopworx/operator';
import MaintenancePlan from '@shopworx/maintenance-plan';
import MaintenanceTask from '@shopworx/maintenance-task';
import ProductionLayoutSF from '@shopworx/production-layout-sf';
import ProductionPlanningCamso from '@shopworx/production-planning-camso';
import AssemblyPlanning from '@shopworx/assembly-planning';
import AssemblyPlanningTaco from '@shopworx/assembly-planning-taco';
import AssemblyPlanningDover from '@shopworx/assembly-planning-dover';
import FileManager from '@shopworx/file-manager';
import ProductionPlanningVista from '@shopworx/production-planning-vista';
import ReceivingProductionVista from '@shopworx/receiving-production-vista';
import ManpowerLog from '@shopworx/manpower-log';
import PartstatusManagement from '@shopworx/partstatus-management';
import ReportExport from '@shopworx/report-export';
import ChecklistReport from '@shopworx/checklist-report';
import TraceabilityReport from '@shopworx/traceability-report';
import TraceabilityTaco from '@shopworx/traceability-taco';
import Alerts from '@shopworx/alerts';
import Machine from '@shopworx/machine';
import Sales from '@shopworx/sales';
import Planning from '@shopworx/planning';
import MonthlyPlanning from '@shopworx/monthly-planning';
import store from './store';
import router from './router';
import i18n from './i18n';

Vue.use(ParameterConfigurationMes, {
  router,
  store,
  i18n,
});
Vue.use(DataVisualizer, {
  router,
  store,
  i18n,
});
Vue.use(DataAnalyzer, {
  router,
  store,
  i18n,
});
Vue.use(MaterialManagement, {
  router,
  store,
  i18n,
});
Vue.use(Admin, {
  router,
  store,
  i18n,
});
Vue.use(TraceabilityApp, {
  router,
  store,
  i18n,
});
Vue.use(RoadmapManagement, {
  router,
  store,
  i18n,
});

Vue.use(PackagingManagement, {
  router,
  store,
  i18n,
});

Vue.use(ProductionProcess, {
  router,
  store,
  i18n,
});

Vue.use(ProductManagement, {
  router,
  store,
  i18n,
});
Vue.use(RecipeManagement, {
  router,
  store,
  i18n,
});
Vue.use(OrderManagement, {
  router,
  store,
  i18n,
});
Vue.use(Masters, {
  router,
  store,
  i18n,
});
Vue.use(ProductionPlanning, {
  router,
  store,
  i18n,
});
Vue.use(ProductionLog, {
  router,
  store,
  i18n,
});

Vue.use(DowntimeLog, {
  router,
  store,
  i18n,
});

Vue.use(ReportViewer, {
  router,
  store,
  i18n,
});
Vue.use(Setup, {
  router,
  store,
  i18n,
});
Vue.use(Spc, {
  router,
  store,
  i18n,
});
Vue.use(UserDashboard, {
  router,
  store,
  i18n,
});
Vue.use(BillingApp, {
  router,
  store,
  i18n,
});
Vue.use(KpiDashboard, {
  router,
  store,
  i18n,
});
Vue.use(BottleneckMachineDashboard, {
  router,
  store,
  i18n,
});

Vue.use(NgCodeConfiguration, {
  router,
  store,
  i18n,
});

Vue.use(ReworkOperation, {
  router,
  store,
  i18n,
});

Vue.use(ProductionImage, {
  router,
  store,
  i18n,
});

Vue.use(ModelManagement, {
  router,
  store,
  i18n,
});

Vue.use(ProductionLayoutMes, {
  router,
  store,
  i18n,
});

Vue.use(Solution, {
  router,
  store,
  i18n,
});

Vue.use(Operator, {
  router,
  store,
  i18n,
});

Vue.use(Machine, {
  router,
  store,
  i18n,
});

Vue.use(MaintenancePlan, {
  router,
  store,
  i18n,
});

Vue.use(MaintenanceTask, {
  router,
  store,
  i18n,
});

Vue.use(Cron, {
  router,
  store,
  i18n,
});

Vue.use(ProductionLayoutSF, {
  router,
  store,
  i18n,
});

Vue.use(ManualInbound, {
  router,
  store,
  i18n,
});

Vue.use(ManualOutbound, {
  router,
  store,
  i18n,
});

Vue.use(StockTaking, {
  router,
  store,
  i18n,
});

Vue.use(calibrationApp, {
  router,
  store,
  i18n,
});

Vue.use(PartstatusManagement, {
  router,
  store,
  i18n,
});

Vue.use(ProductionPlanningCamso, {
  router,
  store,
  i18n,
});

Vue.use(ManpowerLog, {
  router,
  store,
  i18n,
});

Vue.use(AssemblyPlanning, {
  router,
  store,
  i18n,
});

Vue.use(AssemblyPlanningDover, {
  router,
  store,
  i18n,
});

Vue.use(AssemblyPlanningTaco, {
  router,
  store,
  i18n,
});

Vue.use(FileManager, {
  router,
  store,
  i18n,
});

Vue.use(Sales, {
  router,
  store,
  i18n,
});

Vue.use(Planning, {
  router,
  store,
  i18n,
});

Vue.use(ProductionPlanningVista, {
  router,
  store,
  i18n,
});

Vue.use(ReceivingProductionVista, {
  router,
  store,
  i18n,
});

Vue.use(ChecklistReport, {
  router,
  store,
  i18n,
});

Vue.use(TraceabilityReport, {
  router,
  store,
  i18n,
});

Vue.use(Alerts, {
  router,
  store,
  i18n,
});

Vue.use(TraceabilityTaco, {
  router,
  store,
  i18n,
});

Vue.use(PartstatusManagement, {
  router,
  store,
  i18n,
});

Vue.use(ReportExport, {
  router,
  store,
  i18n,
});

Vue.use(CellwiseDowntimeDashboard, {
  router,
  store,
  i18n,
});

Vue.use(CellwiseQualityDashboard, {
  router,
  store,
  i18n,
});

Vue.use(CellwiseProductionDashboard, {
  router,
  store,
  i18n,
});

Vue.use(emsDashboard, {
  router,
  store,
  i18n,
});

Vue.use(MonthlyPlanning, {
  router,
  store,
  i18n,
});
